module.exports = __webpack_public_path__ + "img/bathroom.890588df.svg";